import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import LogList from './LogList';
import { parseJSON } from '../../utils/helpers';

const Logs = () => {
  const dispatch = useDispatch();
  const { logs, loadingLogs } = useSelector((state) => state.general);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(25);
  const [logType, setLogType] = useState('FULL_RULE');

  const fetchLogs = () => {
    dispatch(generalSet({ reduxField: 'loadingLogs', value: true }));
    dispatch(apiAction({ reduxField: 'logs', route: 'logs/getLogs', page, size, logType, setLoading: 'loadingLogs' }));
  };

  useEffect(() => {
    fetchLogs();
  }, [dispatch, page, size]);
  console.log({
    logs,
    filtered: logs
      ?.map((log) => {
        if (parseJSON(log.jsonData).action?.actionType === 'DUPLICATE_CAMPAIGN') {
          return { ...log, jsonData: parseJSON(log.jsonData) };
        }
        return null;
      })
      .filter(Boolean),
  });
  return Array.isArray(logs) ? (
    <LogList logs={logs} logType={logType} setLogType={setLogType} fetchLogs={fetchLogs} loadingLogs={loadingLogs} />
  ) : (
    <Spinner />
  );
};

export default Logs;
